import _ from 'lodash';
import moment from 'moment';

import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Page, LoadingPage } from '../shared';

import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

import Select from 'react-select';

import { LocalizationsSelector } from '../../selectors';

import Fourbox from './fourbox';
import TalentDefinitions from './talentDefinitions';
import { TrackGoalModal, ConfirmModal, UpdateSprintDatesModal, ReviewAndSubmitSprintModal } from '../modals';
import {
  calculateLikelySprintStartAndEndDatesFromCurrentDate,
  formatNewLines,
  sprintGoalsAreDirty,
  currentUserRole,
  print,
  getSellingCompetency,
} from '../../util';
import {
  getReportingAndEvaluationPeriodsForThisYear,
  isInEvaluationPeriodForCurrentQuarter,
  getNextQuarterString,
  isWithinOneMonthOfLastEvaluationPeriod,
} from '../../util/quarters';

import {
  fetchSprintHistoryForEmployee,
  fetchCurrentSprintForEmployee,
  saveCurrentSprintForEmployee,
  submitSprintForReview,
  finalizeSprint
} from '../../actions/sprint';

import { getIcon } from '../../util/icons';

class SprintPage extends Component {

  state = {
    employeeId: null,
    isOwnSprint: true,
    cachedSprint: null,
    updatedSprint: null,
    showingSubmitConfirmModal: false,
    submittingSprint: false,
    finalizingSprint: false,
    editingAsManager: false,
    viewingHistoricSprint: null,
    showingHistorySelect: false,
    showingFinalizeConfirmModal: false,
    showingReviewAndSubmitModal: false,
    trackingGoal: null,
    sprintHistoryFetched: false,
  }

  sprintIsDirty(){
    if(!this.state.cachedSprint || !this.state.updatedSprint){
      return false;
    }

    // console.log('comparing: ', this.state.cachedSprint.goals);
    // console.log('to: ', this.state.updatedSprint.goals);
    return sprintGoalsAreDirty(this.state.cachedSprint.goals, this.state.updatedSprint.goals);
  }

  currentRoleIsViewOnly(){
    //return currentUserRole() === 'salesleader' || currentUserRole() === 'admin';

    //Based on discussion with XDD / Greg on 1/11/19, sales leaders should be able to go in and setup sprints for employees. IMO if sales leaders
    //can do it, admins should also be able to do this. So for now, I'm just going to say that no roles are read only until we determine there to be
    //a use case for this.
    return false;
  }

  fourboxIsEditable(){

    //sales leaders shouldn't be editing these reports
    if(this.currentRoleIsViewOnly()){
      return false;
    }
    if(this.currentSprintIsForNextQuarter()){
      return false;
    }

    const fourboxIsEditable = (this.state.isOwnSprint && this.props.fourboxStatus === 'editing') || this.state.editingAsManager;

    return fourboxIsEditable;
  }

  actionItemsEditable(){
    if(this.currentRoleIsViewOnly()){
      return false;
    }

    return !this.state.isOwnSprint && this.props.fourboxStatus === 'submitted';
  }

  updateSprintGoalMeta(goalId, newMetadata){
    //make a copy to update
    let updatedSprint = _.cloneDeep(this.state.updatedSprint);

    let matchingGoal = _.find(updatedSprint.goals, goal => {
      return goal.id === goalId;
    });

    // console.log('updating goal metadata: ', newMetadata);

    matchingGoal.goalMeta = {
      ...matchingGoal.goalMeta,
      ...newMetadata
    }

    // console.log('new matching goal: ', matchingGoal);

    this.setState({
      updatedSprint
    });
  }

  updateSprintGoalValue(goalId, newValue){

    //make a copy to update
    let updatedSprint = _.cloneDeep(this.state.updatedSprint);

    let matchingGoal = _.find(updatedSprint.goals, goal => {
      return goal.id === goalId;
    });

    matchingGoal.goalValue = newValue;

    //console.log('updated goalValue for matching goal!');

    this.setState({
      updatedSprint
    });
  }

  updateCustomGoalValues(goalId, newValues){
    let updatedSprint = _.cloneDeep(this.state.updatedSprint);

    let matchingGoal = _.find(updatedSprint.goals, goal => {
      return goal.id === goalId;
    });

    matchingGoal.customGoalValues = {
      ...matchingGoal.customGoalValues,
      ...newValues
    }

    //console.log('updated goalValue for matching goal!');

    this.setState({
      updatedSprint
    });
  }

  updateNextWeekActionItems(newValue){
    let updatedSprint = _.cloneDeep(this.state.updatedSprint);

    updatedSprint.nextWeekActionItems = newValue;

    this.setState({
      updatedSprint
    });
  }

  trackGoal(goal){
    this.setState({
      trackingGoal: goal
    });
  }
  hideGoal(){
    this.setState({
      trackingGoal: null
    });
  }

  renderHistoricSprintCard(){
    const userDataForFourbox = (this.props.viewingUser.data ? this.props.viewingUser.data : this.props.user);

    const historicSprintHadCompetenciesEnabled = _.size(_.filter(this.state.viewingHistoricSprint.goals, goal => {
      return goal.cateogry === 'behavior' || goal.category === 'skill';
    })) === 0;

    return (
      <div className="sprint-card">
        <Fourbox
          userData={userDataForFourbox}
          competenciesEnabled={historicSprintHadCompetenciesEnabled}
          sprintData={this.state.viewingHistoricSprint}
          trackGoal={this.trackGoal.bind(this)}
        />
      </div>
    )
  }
  renderCurrentSprintCard(){

    const userDataForFourbox = (this.props.viewingUser.data ? this.props.viewingUser.data : this.props.user);

    return (
      <div className="sprint-card">
        <Fourbox
          userData={userDataForFourbox}
          competenciesEnabled={this.props.competenciesEnabled}
          editable={this.fourboxIsEditable()}
          editingActionItems={this.actionItemsEditable()}
          sprintData={this.state.updatedSprint}
          updateGoalValue={this.updateSprintGoalValue.bind(this)}
          updateGoalMeta={this.updateSprintGoalMeta.bind(this)}
          updateCustomGoalValues={this.updateCustomGoalValues.bind(this)}
          updateNextWeekActionItems={this.updateNextWeekActionItems.bind(this)}
          trackGoal={this.trackGoal.bind(this)}
          lastSprintOfQuarter={this.currentSprintIsLastSprintOfQuarter()}
          localizations={this.props.localizations}
        />
      </div>
    )
  }

  sprintUserName(){
    const { viewingUser, user } = this.props;

    const { isOwnSprint } = this.state;

    const userData = isOwnSprint ? user : viewingUser.data;

    return (userData || {}).firstName;
  }

  renderSetupPrompt(){

    const { isOwnSprint } = this.state;

    return (
      <div className="page-section">
        {isOwnSprint &&
          <div className="empty-state">
            {getIcon('info')}
            <p>Awaiting your sprint goals to be configured by your manager...</p>
          </div>
        }
        {!isOwnSprint &&
          <div className="empty-state">
            {getIcon('info')}
            <p>You need to configure sprint goals for this employee!<br/><Link to="./sprint/setup">Setup {`${this.sprintUserName()}'s`} sprint goals</Link></p>
          </div>
        }
      </div>
    )
  }

  saveSprint(){
    this.props.saveCurrentSprintForEmployee(this.state.updatedSprint._id, this.state.updatedSprint, sprint => {
      this.setState({
        cachedSprint: sprint,
        updatedSprint: sprint
      });
    });

    //if manager is editing, automatically bring back to "review" state
    if(this.state.editingAsManager){
      this.setState({
        editingAsManager: false,
      });
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.sprint.error){
      this.setState({
        pageMessage: {
          messageType: 'error',
          messageContent: nextProps.sprint.error
        }
      });
    }
    if(!nextProps.savingSprint && nextProps.sprintData){
      //if we receive new AND different sprint data
      // if(sprintGoalsAreDirty(this.state.cachedSprint.goals, nextProps.sprintData.goals)){
      //   this.setState({
      //     cachedSprint: nextProps.sprintData,
      //     updatedSprint: nextProps.sprintData,
      //   });
      // }
    }
  }

  fetchSprintHistory(callback){
    const { employeeId } = this.state;

    this.props.fetchSprintHistoryForEmployee(employeeId, callback);
  }

  componentWillMount(){
    console.log('component will mount!');

    const { match: { params } } = this.props;

    let employeeId = params.employeeId;

    //if no employeeId...user accessing sprint
    //TODO figure out a better way of managing this
    if(employeeId){
      this.setState({
        employeeId,
        isOwnSprint: false,
      })
    }
    else{
      employeeId = this.props.user.uid;

      this.setState({
        employeeId,
        isOwnSprint: true,
      });
    }

    this.props.fetchCurrentSprintForEmployee(employeeId, sprint => {
      this.setState({
        cachedSprint: sprint,
        updatedSprint: sprint,
      })
    });
  }

  renderPageTitle(){
    const { sprintIsSetup, viewingUser, user } = this.props;

    const { isOwnSprint } = this.state;

    const userData = isOwnSprint ? user : viewingUser.data;

    const viewingHistoricSprint = this.state.viewingHistoricSprint ? true : false;

    const sprint = this.state.viewingHistoricSprint ? this.state.viewingHistoricSprint : this.props.sprintData;

    if(!sprint || !userData){
      return null;
    }

    const { submittedOn, reviewedOn, userRating, managerRating } = sprint;

    const firstNameForRating = isOwnSprint ? 'Your' : userData.firstName + '\'s';

    const currentSprintIsPausedForSetup = this.currentSprintIsPausedForSetup();

    if(currentSprintIsPausedForSetup && !this.state.viewingHistoricSprint){
      return (
        <div className="page-title">
          <h1>Sprint not setup</h1>
          {isOwnSprint &&
            <h3>Your sprint has not been setup for this quarter</h3>
          }
          {!isOwnSprint &&
            <h3>You have not updated {`${userData.firstName}\'s`} sprint for {isInEvaluationPeriodForCurrentQuarter() ? 'next' : 'this'} quarter</h3>
          }
        </div>
      );
    }
    else if(sprintIsSetup){

      return (
        <div className="page-title">
          <h1>Velocity Sprint</h1>
          <h1 className="right-header-for-printing">{userData.firstName + ' ' + userData.lastName}</h1>

          {submittedOn && submittedOn.toDate && !reviewedOn &&
            <h3>Submitted on {moment(submittedOn.toDate()).format('M/D')} <small>at {moment(submittedOn.toDate()).format('h:mm A')}</small></h3>
          }
          {reviewedOn && reviewedOn.toDate &&
            <h3>Reviewed & approved on {moment(reviewedOn.toDate()).format('M/D')}</h3>
          }
          {!isOwnSprint && !submittedOn && !reviewedOn && !this.currentSprintIsForNextQuarter() &&
            <h3>Employee still editing</h3>
          }
          {this.currentSprintIsForNextQuarter() && !viewingHistoricSprint &&
            <h3>Sprint ready to go for {getNextQuarterString()}</h3>
          }
          {userRating &&
            <div className="stats fs-block">
              <div data-for="user-rating-tooltip" className="stat with-icon" data-tip={firstNameForRating + ' rating for this sprint'}>{getIcon('avatar')}{userRating}/5</div>
              <ReactTooltip id="user-rating-tooltip" effect="solid" place="top" />
              {managerRating &&
                <React.Fragment>
                  <div className="stat with-icon" data-for="manager-rating-tooltip" data-tip={'Manager rating for this sprint'}>{getIcon('signature')}{managerRating}/5<ReactTooltip effect="solid" place="top"/></div>
                  <ReactTooltip id="manager-rating-tooltip" effect="solid" place="top" />
                </React.Fragment>
              }
            </div>
          }
        </div>
      );
    }
    else{
      return (
        <div className="page-title">
          <h1>Velocity Sprint</h1>
          {isOwnSprint &&
            <h3>Your Velocity Sprint is not setup yet.</h3>
          }
          {!isOwnSprint &&
            <h3>Sprint not setup for {userData.firstName}</h3>
          }
        </div>
      );
    }
  }

  showSubmitConfirm(){
    this.setState({
      showingSubmitConfirmModal: true
    });
  }
  hideSubmitConfirm(){
    this.setState({
      showingSubmitConfirmModal: false
    });
  }

  submitSprintWithRating(rating){

    const updatedSprint = {
      ...this.state.updatedSprint,
      userRating: rating,
    }

    this.setState({
      submittingSprint: true
    });

    this.props.submitSprintForReview(updatedSprint, () => {
      //hide modal and set submitting to false
      this.setState({
        showingSubmitConfirmModal: false,
        showingReviewAndSubmitModal: false,
        submittingSprint: false,
        pageMessage: {
          messageType: 'success',
          messageContent: 'Sprint submitted for review',
          expireAfter: 5000,
        }
      });
    });
  }
  renderSubmitConfirmModal(){
    const message = 'You are about to submit your Velocity Sprint for this week. Your sprint will be sent to your manager and you will not be able to change any values once submitted.';

    return <ConfirmModal
      iconKey="send"
      confirmText="Next"
      message={message}
      onConfirm={this.showReviewAndSubmitModal.bind(this)}
      hide={this.hideSubmitConfirm.bind(this)}
      visible={this.state.showingSubmitConfirmModal}
      />
  }

  renderTrackGoalModal(){

    const trackingGoal = this.state.trackingGoal;

    if(!trackingGoal){
      return null;
    }

    let goalData = {};

    if(this.state.viewingHistoricSprint){
      goalData = trackingGoal;
    }
    else{
      goalData = _.find(this.state.updatedSprint.goals, goal => {
        return goal.id === trackingGoal.id;
      });
    }

    console.log('track goal modal with viewingHistoricSprint: ', this.state.viewingHistoricSprint);

    //if not viewing historic sprint and we have edit capabilities (is my sprint or is editing as manager)
    const trackGoalIsEditable = this.fourboxIsEditable() && !this.state.viewingHistoricSprint && (this.state.isOwnSprint || this.state.editingAsManager) && !this.currentSprintIsForNextQuarter();

    const goalMetaData = {};

    if(this.props.competenciesEnabled){
      if(goalData.category === 'competency'){
        const matchingCompetencyDescription = (getSellingCompetency(goalData.id) || {}).description;

        if(matchingCompetencyDescription){
          goalMetaData.description = matchingCompetencyDescription;
        }
      }
      else if(goalData.category === 'expertise'){
        const matchingExpertiseItem = _.find(((this.props.organizationData || {}).expertiseItems || []), {id: goalData.id});

        if(matchingExpertiseItem && matchingExpertiseItem.description){
          goalMetaData.description = matchingExpertiseItem.description;
        }
      }
    }

    return <TrackGoalModal
      goal={goalData}
      updateGoalValue={this.updateSprintGoalValue.bind(this)}
      updateGoalMeta={this.updateSprintGoalMeta.bind(this)}
      hide={this.hideGoal.bind(this)}
      visible={this.state.trackingGoal}
      editing={trackGoalIsEditable}
      goalMetaData={goalMetaData}
      />
  }

  showReviewAndSubmitModal(){
    this.setState({
      showingFinalizeConfirmModal: false,
      showingSubmitConfirmModal: false,
      showingReviewAndSubmitModal: true,
    });
  }
  hideReviewAndSubmitModal(){
    this.setState({
      showingReviewAndSubmitModal: false,
    });
  }

  renderReviewAndSubmitModal(){

    const { isOwnSprint } = this.state;

    const confirmText = isOwnSprint ? 'Submit for Review' : 'Finish Review';
    const confirmingText = isOwnSprint ? 'Submitting' : 'Finalizing';

    const confirming = isOwnSprint ? this.state.submittingSprint : this.state.finalizingSprint;

    const confirmAction = isOwnSprint ? this.submitSprintWithRating.bind(this) : this.finalizeSprintWithRating.bind(this);

    return <ReviewAndSubmitSprintModal
      reviewingOwnSprint={isOwnSprint}
      confirming={confirming}
      confirmingText={confirmingText}
      confirmText={confirmText}
      onConfirm={confirmAction}
      visible={this.state.showingReviewAndSubmitModal}
      hide={this.hideReviewAndSubmitModal.bind(this)}
      />
  }

  showFinalizeConfirm(){

    let finalizeConfirmState = {
      showingFinalizeConfirmModal: true
    }

    //set start and end dates on sprint if not set
    if(!this.state.updatedSprint.startDate || !this.state.updatedSprint.endDate){
      const sprintWithStartAndEndDates = {
        ...this.state.updatedSprint,
        ...calculateLikelySprintStartAndEndDatesFromCurrentDate(),
      };

      finalizeConfirmState.updatedSprint = sprintWithStartAndEndDates;
    }

    this.setState(finalizeConfirmState);
  }
  hideFinalizeConfirm(){
    this.setState({
      showingFinalizeConfirmModal: false
    });
  }

  finalizeSprintWithRating(rating){

    this.setState({
      finalizingSprint: true
    });

    const updatedSprint = {
      ...this.state.updatedSprint,
      managerRating: rating,
    }

    const successMessage = this.currentSprintIsLastSprintOfQuarter() ? 'Sprint finalized and reset for next quarter' : 'Sprint finalized and reset for next week'

    this.props.finalizeSprint(updatedSprint, newHistoricSprintId => {

      console.log('finalize sprint callback in sprint/index.js');

      //refresh sprint history
      this.fetchSprintHistory(() => {
        this.setState({
          showingFinalizeConfirmModal: false,
          showingReviewAndSubmitModal: false,
          finalizingSprint: false,
          pageMessage: {
            messageType: 'notification',
            messageContent: successMessage,
            expireAfter: 5000,
          },
          sprintHistoryFetched: true,
        });

        this.viewHistorySprintById(newHistoricSprintId);
      });
    });
  }
  changeDatesForSprint(){
    this.setState({
      showingFinalizeConfirmModal: false,
      showingChangeSprintDatesModal: true,
    });
  }
  renderFinalizeConfirmModal(){

    const updatedSprint = this.state.updatedSprint;

    if(!updatedSprint || !updatedSprint.startDate || !updatedSprint.endDate){
      return null;
    }

    const isVisible = this.state.showingFinalizeConfirmModal;

    const startDate = moment(updatedSprint.startDate).format('dddd MMMM Do');
    const endDate = moment(updatedSprint.endDate).format('dddd MMMM Do');

    const messageHtml = `<h2>Finish reviewing?</h2><p>This sprint will be added to your team and organization reports and you will not be able to change any values once finalized.</p><p><small>Please confirm the sprint dates before finishing review:<br/><b>${startDate} - ${endDate}</b></small></p>`;

    return <ConfirmModal
      iconKey="lock"
      confirmText="Next"
      messageHtml={messageHtml}
      onConfirm={this.showReviewAndSubmitModal.bind(this)}
      hide={this.hideFinalizeConfirm.bind(this)}
      secondaryActionText={'Change dates'}
      onSecondaryAction={this.changeDatesForSprint.bind(this)}
      visible={isVisible}
      />
  }

  updateSprintDates(startDate, endDate){

    this.setState({
      updatedSprint: {
        ...this.state.updatedSprint,
        startDate,
        endDate
      },
      showingFinalizeConfirmModal: true,
      showingChangeSprintDatesModal: false,
    });
  }

  renderUpdateSprintDatesModal(){

    if(!this.state.updatedSprint || !this.state.updatedSprint.startDate || !this.state.updatedSprint.endDate){
      return null;
    }

    const isVisible = this.state.showingChangeSprintDatesModal;

    const { startDate, endDate } = this.state.updatedSprint;

    console.log('dates from updated sprint: ', startDate, ' endDate: ', endDate);

    return <UpdateSprintDatesModal
      onUpdateDates={this.updateSprintDates.bind(this)}
      visible={isVisible}
      startDate={startDate}
      endDate={endDate}
      hide={() => { this.setState({ showingFinalizeConfirmModal: true, showingChangeSprintDatesModal: false }); }}
      />
  }

  currentSprintIsLastSprintOfQuarter(){
    if(!this.currentSprintIsForNextQuarter() && isInEvaluationPeriodForCurrentQuarter()){
      return true;
    }

    return false;
  }
  currentSprintIsForNextQuarter(){
    return (this.state.updatedSprint || {}).period === getNextQuarterString();
  }
  currentSprintIsPausedForSetup(){
    return (this.state.updatedSprint || {}).status === 'paused';
  }

  editAsManager(){
    this.setState({
      editingAsManager: true,
    });
  }

  cancelEditingAsManager(){
    this.setState({
      editingAsManager: false,
      updatedSprint: this.state.cachedSprint,
    });
  }

  finishReviewButtonEnabled(){
    const nextWeekActionItemsAreSet = (this.state.updatedSprint && this.state.updatedSprint.nextWeekActionItems && this.state.updatedSprint.nextWeekActionItems !== '');
    return this.state.updatedSprint && (nextWeekActionItemsAreSet || this.currentSprintIsLastSprintOfQuarter());
  }

  fetchSprintHistoryIfNotFetched(){
    if(!this.state.sprintHistoryFetched && !this.props.sprintHistory.loading){
      this.fetchSprintHistory(() => {
        this.setState({
          sprintHistoryFetched: true
        });
      });
    }
  }

  getSprintHistoryOptionsForSelect(){

    const currentWeekOption = {
      value: false,
      label: 'This week'
    }

    if(this.props.sprintHistory.loading){
      return [currentWeekOption,{
        value: null,
        label: 'Loading...'
      }]
    }
    else{
      const sprintHistoryOptions = _.map(this.props.sprintHistory.data, sprint => {
        return {
          value: sprint._id,
          label: moment(sprint.startDate).format('M/D') + ' - ' + moment(sprint.endDate).format('M/D')
        }
      });

      return _.union([currentWeekOption], sprintHistoryOptions);
    }
  }
  getSprintHistorySelectValue(){
    const { viewingHistoricSprint } = this.state;

    if(viewingHistoricSprint){
      return {
        value: viewingHistoricSprint._id,
        label: moment(viewingHistoricSprint.startDate).format('M/D') + ' - ' + moment(viewingHistoricSprint.endDate).format('M/D')
      }
    }
    else{
      return {
        value: false,
        label: 'This week'
      }
    }
  }

  viewHistorySprintById(sprintId){
    if(!sprintId || !this.props.sprintHistory.data){
      //current sprint
      this.setState({
        viewingHistoricSprint: false,
        showingHistorySelect: false,
      });
    }
    else{
      //find sprint
      const sprintToView = _.find(this.props.sprintHistory.data, sprint => {
        return sprint._id === sprintId;
      });

      if(sprintToView){
        this.setState({
          viewingHistoricSprint: sprintToView
        });
      }
    }
  }

  renderPageActions(){
    const { sprintIsSetup, savingSprint, fourboxStatus } = this.props;
    const { isOwnSprint, editingAsManager, viewingHistoricSprint, showingHistorySelect, updatedSprint } = this.state;

    const currentRoleIsViewOnly = this.currentRoleIsViewOnly();
    const fourboxIsEditable = this.fourboxIsEditable();
    const currentSprintIsForNextQuarter = this.currentSprintIsForNextQuarter();
    const currentSprintIsPausedForSetup = this.currentSprintIsPausedForSetup();

    const viewingArchivedSprint = this.viewingArchivedSprint();

    if(viewingArchivedSprint){
      return (
        <div className="page-actions">
          {!showingHistorySelect &&
            <React.Fragment>
              <div data-for="view-previous-reports-tooltip" data-tip="View previous reports" onClick={() => { this.fetchSprintHistoryIfNotFetched(); this.setState({ showingHistorySelect: true }) }} className="action">{getIcon('history', 'light')}</div>
              <ReactTooltip id="view-previous-reports-tooltip" effect="solid" place="top"/>
            </React.Fragment>
          }
          {showingHistorySelect &&
            <Select
              classNamePrefix={'react-select'}
              className='react-select-container sprint-history-select'
              value={this.getSprintHistorySelectValue()}
              options={this.getSprintHistoryOptionsForSelect()}
              onChange={(option) => { this.viewHistorySprintById(option.value) }}
              isSearchable={false}
            />
          }
        </div>
      )
    }
    else if(currentSprintIsPausedForSetup){
      return (
        <div className="page-actions">
          {!editingAsManager && !viewingHistoricSprint && !isOwnSprint &&
            <Link to="./sprint/setup"><button className="button primary">Update goals for {getReportingAndEvaluationPeriodsForThisYear().current.label}</button></Link>
          }
          {!editingAsManager && viewingHistoricSprint &&
            <React.Fragment>
              <div data-for="print-report-tooltip" data-tip="Print report" onClick={print} className="action">{getIcon('print', 'light')}</div>
              <ReactTooltip id="print-report-tooltip" effect="solid" place="top"/>
            </React.Fragment>
          }
          {!editingAsManager && !showingHistorySelect &&
            <React.Fragment>
              <div data-for="view-previous-reports-tooltip" data-tip="View previous reports" onClick={() => { this.fetchSprintHistoryIfNotFetched(); this.setState({ showingHistorySelect: true }) }} className="action">{getIcon('history', 'light')}</div>
              <ReactTooltip id="view-previous-reports-tooltip" effect="solid" place="top"/>
            </React.Fragment>
          }
          {!editingAsManager && showingHistorySelect &&
            <Select
              classNamePrefix={'react-select'}
              className='react-select-container sprint-history-select'
              value={this.getSprintHistorySelectValue()}
              options={this.getSprintHistoryOptionsForSelect()}
              onChange={(option) => { this.viewHistorySprintById(option.value) }}
              isSearchable={false}
            />
          }
        </div>
      );
    }
    else if(sprintIsSetup){
      return (
        <div className="page-actions">
          {fourboxIsEditable && !viewingHistoricSprint && !currentSprintIsForNextQuarter &&
            <button onClick={this.saveSprint.bind(this)} className="button primary" disabled={!this.sprintIsDirty() || savingSprint}>{savingSprint ? 'Saving...' : 'Save'}</button>
          }
          {fourboxIsEditable && editingAsManager &&
            <button onClick={this.cancelEditingAsManager.bind(this)} className="button grey-outline">Cancel</button>
          }
          {isOwnSprint && fourboxIsEditable && !viewingHistoricSprint && !currentSprintIsForNextQuarter &&
            <button onClick={this.showSubmitConfirm.bind(this)} className="button primary-outline">Submit for Review</button>
          }
          {isOwnSprint && (updatedSprint || {}).status === 'submitted' && !viewingHistoricSprint &&
            <button disabled className="button grey-outline">Awaiting Manager Review</button>
          }
          {!currentRoleIsViewOnly && !isOwnSprint && !editingAsManager && fourboxStatus === 'submitted' && !viewingHistoricSprint &&
            <button onClick={this.showFinalizeConfirm.bind(this)} className="button primary" disabled={!this.finishReviewButtonEnabled()}>Finish Review</button>
          }
          {!currentRoleIsViewOnly && !isOwnSprint && !editingAsManager && !viewingHistoricSprint && !currentSprintIsForNextQuarter &&
            <React.Fragment>
              <div data-for="edit-report-tooltip" data-tip="Edit report" onClick={this.editAsManager.bind(this)} className="action">{getIcon('edit', 'light')}</div>
              <ReactTooltip id="edit-report-tooltip" effect="solid" place="top"/>
            </React.Fragment>
          }
          {!editingAsManager && (!currentSprintIsForNextQuarter || viewingHistoricSprint) &&
            <React.Fragment>
              <div data-for="print-report-2-tooltip" data-tip="Print report" onClick={print} className="action">{getIcon('print', 'light')}</div>
              <ReactTooltip id="print-report-2-tooltip" effect="solid" place="top"/>
            </React.Fragment>
          }
          {!currentRoleIsViewOnly && !isOwnSprint && fourboxStatus === 'editing' && !editingAsManager && !viewingHistoricSprint &&
            <React.Fragment>
              <Link data-for="configure-goals-tooltip" data-tip="Configure goals" to="./sprint/setup">{getIcon('tools', 'light')}</Link>
              <ReactTooltip id="configure-goals-tooltip" effect="solid" place="top"/>
            </React.Fragment>
          }
          {!editingAsManager && !showingHistorySelect &&
            <React.Fragment>
              <div data-for="view-previous-reports-2-tooltip" data-tip="View previous reports" onClick={() => { this.fetchSprintHistoryIfNotFetched(); this.setState({ showingHistorySelect: true }) }} className="action">{getIcon('history', 'light')}</div>
              <ReactTooltip id="view-previous-reports-2-tooltip" effect="solid" place="top"/>
            </React.Fragment>
          }
          {!editingAsManager && showingHistorySelect &&
            <Select
              classNamePrefix={'react-select'}
              className='react-select-container sprint-history-select'
              value={this.getSprintHistorySelectValue()}
              options={this.getSprintHistoryOptionsForSelect()}
              onChange={(option) => { this.viewHistorySprintById(option.value) }}
              isSearchable={false}
            />
          }
        </div>
      );
    }
    else if(!isOwnSprint && !currentRoleIsViewOnly){
      return (
        <div className="page-actions">
          <Link to="./sprint/setup"><button className="button primary">Setup sprint goals...</button></Link>
        </div>
      );
    }
    else{
      return null;
    }
  }

  renderSprintCardDefinitionsForPrinting(){
    const userData = this.props.viewingUser.data ? this.props.viewingUser.data : this.props.user;

    const sprintData = this.state.viewingHistoricSprint ? this.state.viewingHistoricSprint : this.state.updatedSprint;

    if(!userData || !sprintData){
      return null;
    }

    return(
      <TalentDefinitions
        userData={userData}
        sprintData={sprintData}
      />
    )
  }

  viewingArchivedSprint(){
    return !this.state.viewingHistoricSprint && this.props.currentSprintIsArchived;
  }

  renderSprint(){

    const { sprintIsSetup } = this.props;

    const isViewingHistoricSprint = this.state.viewingHistoricSprint ? true : false;

    if(this.viewingArchivedSprint()){
      return (
        <React.Fragment>
          {this.renderPageTitle()}
          {this.renderPageActions()}
          <div className="page-content">
            <div className="page-section">
              <p>This user is archived. Click the history icon in the top right to access sprint history.</p>
            </div>
          </div>
        </React.Fragment>
      )
    }

    return (
      <React.Fragment>
        {this.renderPageTitle()}
        {this.renderPageActions()}
        <div className="page-content">
          {isViewingHistoricSprint && this.renderHistoricSprintCard()}
          {!isViewingHistoricSprint && sprintIsSetup && !this.currentSprintIsPausedForSetup() && this.renderCurrentSprintCard()}
          {!isViewingHistoricSprint && !sprintIsSetup && this.renderSetupPrompt()}
          {!isViewingHistoricSprint && this.currentSprintIsPausedForSetup() && this.renderSprintSetupPrompt()}
        </div>
        <div className="break-page page-content">
          {this.renderSprintCardDefinitionsForPrinting()}
        </div>
      </React.Fragment>
    )
  }
  renderSprintSetupPrompt(){

    const { isOwnSprint } = this.state;

    return (
      <div className="page-section">
        {isOwnSprint &&
          <p>Awaiting this quarter's sprint goals to be setup with your manager...</p>
        }
        {!isOwnSprint &&
          <p>Employee will not be able to complete sprint cards until you update his or her goals for {isInEvaluationPeriodForCurrentQuarter() ? 'next' : 'this'} quarter!</p>
        }
      </div>
    )
  }

  render(){

    //don't attempt to render until organization loaded
    //ideally I'd control this from the <Page> compoenent, but "loading" doesn't prevent the children from rendering
    if(!this.props.organizationData){
      return <LoadingPage pageClass="sprint" />
    }

    const { loading } = this.props.sprint;

    return (
      <Page
        pageClass="sprint"
        loading={loading}
        pageMessage={this.state.pageMessage}
        clearMessage={() => { this.setState({ pageMessage: null }) }}
      >

        {this.renderSprint()}

        {this.renderSubmitConfirmModal()}
        {this.renderFinalizeConfirmModal()}
        {this.renderUpdateSprintDatesModal()}
        {this.renderReviewAndSubmitModal()}
        {this.renderTrackGoalModal()}
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    viewingUser: state.viewingUser,
    savingSprint: state.sprint.saving,
    sprintData: state.sprint.data,
    sprint: state.sprint,
    sprintHistory: state.sprintHistory,
    sprintIsSetup: state.sprint.data && state.sprint.data._id,
    currentSprintIsArchived: state.sprint.data && state.sprint.data.status === 'archived',
    fourboxStatus: state.sprint.data ? state.sprint.data.status : 'loading',
    organizationData: state.organization.data,
    localizations: LocalizationsSelector(state),
    competenciesEnabled: (state.organization.data || {}).competenciesEnabled,
  }
}

export default connect(mapStateToProps, {
  fetchSprintHistoryForEmployee,
  fetchCurrentSprintForEmployee,
  saveCurrentSprintForEmployee,
  submitSprintForReview,
  finalizeSprint
})(SprintPage);



// WEBPACK FOOTER //
// ./src/components/sprint/index.js